import * as types from './constants';

const initialState = {
  data: {},
  publishLoading: false,
  errors_api: {}
};

const actions = {
  // Publish Assignment
  [types.PUBLISH_ASSIGNMENT_REQUEST]: state => {
    const data = {
      ...state,
      publishLoading: true
    };

    return { ...data };
  },

  [types.PUBLISH_ASSIGNMENT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      publishLoading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.PUBLISH_ASSIGNMENT_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      publishLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.PUBLISH_ASSIGNMENT_CLEAR_ERRORS]: (state, { payload }) => {
    let errors_api = { ...state.errors_api };
    let newState = { ...state };
    if (payload) {
      delete errors_api[payload];
    } else {
      errors_api = {};
    }

    return { ...newState, errors_api };
  },

  [types.PUBLISH_ASSIGNMENT_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

